import {lazy, Suspense} from 'react';
import {Skeleton} from '@mui/material';
import {TFunction} from 'i18next';
import BottomBar from '@/shared/components/diagnosticReport/DiagnosticReportForm/steps/BottomBar';

const GlobalDiagnosticReportInstructions = lazy(
  () =>
    import('@/shared/components/diagnosticReport/DiagnosticReportForm/components/FollowUpForm/components/Instructions/components/GlobalDiagnosticReportInstructions')
);

export default function InstructionsStep({
  activeStep,
  onNext,
  t,
  totalSteps
}: {
  activeStep: number;
  onNext: () => void;
  t: TFunction;
  totalSteps: number;
}) {
  return (
    <Suspense fallback={<Skeleton height={200} width="100%" />}>
      <GlobalDiagnosticReportInstructions t={t} />
      <BottomBar
        isBackEnabled={false}
        isBackVisible={false}
        isNextEnabled
        onNext={onNext}
        t={t}
        activeStep={activeStep}
        totalSteps={totalSteps}
      />
    </Suspense>
  );
}
